module.exports = __webpack_public_path__ + "static/media/pt.32f8be86.png";